import styled from 'styled-components'

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  a {
    display: inline-block;
    margin: 0px 5px;
    color: var(--brand-secondary);
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`

export const ContentContainer = styled.div`
  height: 100%;
  width: 60%;
  margin: auto;
  align-items: center;
  display: flex;
  flex-direction: column;
  z-index: 2;
  padding: 80px 0;

  @media (max-width: 768px) {
    width: 90%;
  }
`

export const InnerContent = styled.div`
  width: 90%;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const BlogHeaderBg = styled.div`
  height: 620px;
  width: 100%;
  position: absolute;
  background-color: var(--brand-primary);
  border-radius: 30px 30px 0 0;
  line-height: 1.6;

  @media (max-width: 768px) {
    height: 430px;
  }
`
